interface Name {
  title: string;
  given: string;
  family: string;
}

export const formattedName = ({ title, given, family }: Name) => `${title} ${given} ${family}`;
